import { createContext, useContext, useEffect, useState } from "react";
import { createOrderDoc, createInquiryDoc, getOrderDocs, getInquiryDocs, successToast, updateOrderDoc, getCurrentPage, createPagesDoc, updateInquiryDoc, createGalleryDoc, updateGalleryDoc, getGalleryDocs } from "../utils/firebase/firebase.utils";
import { UserContext } from "./user.context";
import { isAdminProfile } from "../utils/firebase/auth.utils";


export const OrderContext = createContext({
    inquiries: [],
    addInquiry: () => {},
    getInquiry: () => {},
    updateInquiry: () => {},
    orders: [],
    addOrder: () => {},
    getOrders: () => {},
    updateOrder: () => {},
    gallery: [],
    addToGal: () => {},
    getAllGal: () => {},
    updateGal: () => {},
    curPage: null,
    addPage: () => {},
    getCurPage: () => {},
});


export const OrderProvider = ({children}) => {
  const { currentUser, authReady } = useContext(UserContext);
  const [ orders, setClients ] = useState([]);
  const [ inquiries, setInquiries ] = useState([]);
  const [ gallery, setGallery ] = useState([]);
  const [ curPage, setCurPage ] = useState();


  // Inquiry

  const addInquiry = async (docToAdd) => {
    await createInquiryDoc(docToAdd);
    successToast('Inquiry submitted. Our team will reach out to you in 24hrs');
  }

  const updateInquiry = async (docToAdd, msg = 'Reply Sent.') => {
    await updateInquiryDoc(docToAdd);
    await getInquiry();
    successToast(msg);
  }

  const getInquiry = async () => {
    const inquiryMap = await getInquiryDocs();
    setInquiries(inquiryMap);
  }




  // Gallery

  const addToGal = async (docToAdd, msg = 'Image(s) Upload Successful') => {
    await createGalleryDoc(docToAdd);
    await getGallery();
    if (msg) successToast(msg);
  }

  const updateGallery = async (docToAdd, msg = 'Gallery Update Successful.') => {
    await updateGalleryDoc(docToAdd);
    await getGallery();
    if (msg) successToast(msg);
  }

  const getGallery = async () => {
    const galleryMap = await getGalleryDocs();
    setGallery(galleryMap);
  }



  // Client

  const addOrder = async (docToAdd) => {
    await createOrderDoc(docToAdd);
    successToast('Order successful. Our team will get back to you in less than 24 hours');
    if (isAdminProfile(currentUser)) {
      getOrders();
    }
  }

  const getOrders = async () => {
    const clientMap = await getOrderDocs();
    setClients(clientMap);
  }

  const updateOrder = async (docToUpdate, msg = 'Order updated.') => {
    await updateOrderDoc(docToUpdate);
    await getOrders();
    successToast(msg);
  }


  // Pages

  const addPage = async (docToAdd, msg = 'Page updated.') => {
    await createPagesDoc(docToAdd);
    await getCurPage();
    successToast(msg);
  }

  const getCurPage = async () => {
    const pageMap = await getCurrentPage();
    setCurPage(pageMap);
  }


  // Public data only on load
  useEffect(() => {
    getCurPage();
    getGallery();
  }, [])

  // Admin-only lists after auth is ready
  useEffect(() => {
    if (!authReady) return;
    if (isAdminProfile(currentUser)) {
      getInquiry();
      getOrders();
    } else {
      setInquiries([]);
      setClients([]);
    }
  }, [currentUser, authReady])



  const value = { 
    inquiries, addInquiry, updateInquiry, getInquiry,
    orders, addOrder, getOrders, updateOrder,
    curPage, addPage, getCurPage,
    gallery, addToGal, getGallery, updateGallery
  };
  return (<OrderContext.Provider value={value}>{children}</OrderContext.Provider>)
}
